<template>
<div>

<DialogBox :settings="settings" save-on-enter @save="save">

    <div class="pa-4">
        <v-text-field ref="focus" v-model="value" :label="this.settings.title"></v-text-field>
    </div>

</DialogBox>

</div>
</template>

<script>
import DialogBox from '../ui-elements/DialogBox'


export default {
    data() {
        return {
            value: ''
        }
    },
    components: {
        DialogBox
    },

    props: {
        settings: Object
        // Can have: title, visible, description, default
    },

    computed: {

        
    },


    methods: {
        
        save() {
            this.$emit('save', this.value, this.settings)
        },    

        initialiseDialog() {
            if(this.settings.default)
                this.value = this.settings.default
            setTimeout(() => {
                this.$refs.focus.focus()
            },500)
        }
    },

     watch: {
        'settings.visible' (visible) {
            if (visible) {
                this.initialiseDialog()
            }
        }
    },

    created() {
        
    }
}
</script>

<style scoped>
.blue-select {
    border:solid 1px transparent;
}
.blue-select.selected {
    /* background-color: rgb(187, 222, 255); */
    background-color: #E3F2FD;
    border: solid 1px rgb(112, 184, 255);
    box-shadow: 0 0 5px rgb(48, 132, 216);
}
   
</style>




// WEBPACK FOOTER //
// InputDialog.vue?c26b0050